module.exports = __webpack_public_path__ + "img/NL420.0a39f09c.png";